import { Button, Carousel, Col, Layout, Modal, Row } from 'antd';
import { useNavigate } from 'react-router-dom';
import React, { useEffect, useState, useRef } from 'react'
import { ArrowRightOutlined, BarChartOutlined } from '@ant-design/icons';
// import aadhar_ecosystem1 from '../Images/subAuaFlow2.png';
// import aadhar_ecosystem2 from '../Images/AuaFlow2.png';
// import aadhar_ecosystem3 from '../Images/CdacEcosystem2.png';
import aadhar_ecosystem1 from '../Images/AUA-Sub (1).png';
import aadhar_ecosystem3 from '../Images/asaksaservice.jpeg';
import aadhar_ecosystem2 from '../Images/slide1.png';
import ind_flag from '../Images/ind-flag.png';
import AppHeader from '../common/header';
import AOS from 'aos';
import 'aos/dist/aos.css'
import { BackendAPI } from '../../axios';
import TransactionDetails from './TransactionDetails';

const items = [
  {
    key: '1',
    title: 'C-DAC ASA/AUA Service',
    src: aadhar_ecosystem1,
  },
  {
    key: '2',
    title: 'C-DAC AUA/KUA Service',
    src: aadhar_ecosystem2,
  },
  {
    key: '3',
    title: 'Aadhaar Authentication Process Flow for ASA/KSA Service',
    src: aadhar_ecosystem3,
  },
]

const contentStyle: React.CSSProperties = {
  margin: 0,
  height: '100%',
  color: 'blue !important',
  lineHeight: '160px',
  textAlign: 'center',
  background: '#364d79',
};
interface monthDataProps {
  monthData: { month: string; value: number }[];
}
interface weeklyDataProps {
  weekData: { month: string; value: number }[];
}

function BannerHome() {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(false);
  const [isFixed, setIsFixed] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [otpCount, setOtpCount] = useState(0);
  const [authCount, setAuthCount] = useState(0);
  const [kycCount, setKycCount] = useState(0);
  const [deptCount, setDeptCount] = useState(0);
  const [monthlyData, setMonthlyData] = useState<monthDataProps['monthData']>([]);
  const [weeklyData, setWeeklyData] = useState<weeklyDataProps['weekData']>([]);
  const [chartModalVisible, setChartModalVisible] = useState(false);

  const SERVICE_START_YEAR = 2011;
  const currentYear = new Date().getFullYear();
  const yearsOfOperation = Math.max(0, currentYear - SERVICE_START_YEAR);

  // Small CountUp component for animating numbers
  const CountUp: React.FC<{ end: number; duration?: number; suffix?: string }> = ({ end, duration = 2000, suffix = '' }) => {
    const [value, setValue] = useState(0);
    const startRef = useRef<number | null>(null);
    const rafRef = useRef<number | null>(null);

    useEffect(() => {
      const start = performance.now();
      startRef.current = start;

      const step = (now: number) => {
        if (!startRef.current) startRef.current = now;
        const elapsed = now - startRef.current;
        const progress = Math.min(elapsed / duration, 1);
        const current = Math.floor(progress * end);
        setValue(current);
        if (progress < 1) {
          rafRef.current = requestAnimationFrame(step);
        } else {
          setValue(end);
        }
      };

      rafRef.current = requestAnimationFrame(step);

      return () => {
        if (rafRef.current) cancelAnimationFrame(rafRef.current);
      };
    }, [end, duration]);

    return <>{value}{suffix}</>;
  };

  useEffect(() => {
    AOS.init({
      duration: 900,
      once: true,
      easing: 'ease-in-out',
    });

    const handleScroll = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      setIsFixed(scrollTop > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    const header = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const fetchOtpCounts = async () => {
      const url = `/txns/otpCount`;
      try {
        const response = await BackendAPI.get(url, header);
        const result = response.data;
        setOtpCount(result);
      } catch (error) {
        console.error('Error fetching OTP count:', error);
      }
    };
    const fetchAuthCounts = async () => {
      const url = `/txns/authCount`;
      try {
        const response = await BackendAPI.get(url, header);
        const result = response.data;
        setAuthCount(result);
      } catch (error) {
        console.error('Error fetching AUTH count:', error);
      }
    };
    const fetchKycCounts = async () => {
      const url = `/txns/kycCount`;
      try {
        const response = await BackendAPI.get(url, header);
        const result = response.data;
        setKycCount(result);
      } catch (error) {
        console.error('Error fetching KYC count:', error);
      }
    };
    const fetchTotalCounts = async () => {
      const url = `/txns/totalCount`;
      try {
        const response = await BackendAPI.get(url, header);
        const result = response.data;
        setTotalCount(result);
      } catch (error) {
        console.error('Error fetching total count:', error);
      }
    };
    const fetchDepartCount = async () => {
      const url = `/user/deptCount`;
      try {
        const result = await BackendAPI.get(url, header);
        if (!isNaN(Number(result.data))) {
          setDeptCount(Number(result.data));
        } else {
          console.error('Invalid numeric value:', result.data);
        }
      } catch (error) {
        console.error('Error fetching Depart count:', error);
      }
    }
    const fetchMonthwiseData = async () => {
      const url = `/txns/monthWiseCount`;
      try {
        const result = await BackendAPI.get(url, header);
        const apiResponse = result.data;

        if (apiResponse) {
          const updatedData = apiResponse.map(([month, value]: [string, number]) => ({
            month,
            value,
          }));
          setMonthlyData((prevData) => {
            const updatedMonthlyData = [...prevData];

            updatedData.forEach((apiItem: any) => {
              const existingItemIndex = updatedMonthlyData.findIndex(
                (item) => item.month === apiItem.month
              );

              if (existingItemIndex !== -1) {
                updatedMonthlyData[existingItemIndex] = apiItem;
              } else {
                updatedMonthlyData.push(apiItem);
              }
            });

            return updatedMonthlyData;
          });
        } else {
          console.error('Invalid numeric value:', result);
        }
      } catch (error) {
        console.error('Error fetching monthly data', error);
      }
    }

    const fetchWeeklyData = async () => {
      const url = `/txns/weekWiseCount`;
      try {
        const result = await BackendAPI.get(url, header);
        const transformed = result.data.map(([date, YearMonth]: [string, number]) => ({
          date,
          value: Math.floor(YearMonth)
        }));
        const trimmedData = transformed.slice(0, -1);

        setWeeklyData(trimmedData);

      } catch (error) {
        console.error('Error fetching monthly data', error);
      }
    }

    fetchOtpCounts();
    fetchAuthCounts();
    fetchKycCounts();
    fetchTotalCounts();
    fetchDepartCount();
    fetchMonthwiseData();
    fetchWeeklyData();
  }, []);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const totalDisplay =
    typeof totalCount === 'string'
      ? totalCount
      : totalCount >= 10000000
      ? <CountUp end={Math.floor(totalCount / 10000000)} suffix={'Cr+'} duration={1500} />
      : totalCount >= 100000
      ? <CountUp end={Math.floor(totalCount / 100000)} suffix={'L+'} duration={1500} />
      : totalCount >= 1000
      ? <CountUp end={Math.floor(totalCount / 1000)} suffix={'K+'} duration={1500} />
      : <CountUp end={totalCount} duration={1500} />;

  return (
    <>
      <section className="bannerBlock" id='home' style={{ paddingTop: isMobile ? 24 : 48 }}>
        <div className="container-fluid" style={{ maxWidth: 1320, margin: '0 auto', padding: isMobile ? '0 20px' : '0 40px' }}>
          <Row style={{ alignItems: 'flex-start' }} gutter={[32, 32]}>
            <Col
              data-aos="fade-right"
              data-aos-offset="200"
              data-aos-duration="1000"
              data-aos-easing="ease-in-out"
              style={{ padding: 0, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}
              xs={24} sm={24} md={12} lg={12} xl={12}
            >
              <h1 data-aos="fade-right" data-aos-delay="100" style={{
                background: 'linear-gradient(135deg, rgb(0 46 255) 0%, rgb(45 149 225) 25%, rgb(208 50 227) 50%, rgb(3 116 215) 75%, rgb(255 136 0) 100%) text',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                fontSize: '2.8rem',
                textAlign: 'left',
                fontWeight: 800,
                marginTop: 0,
                marginBottom: '20px',
                lineHeight: 1.3
              }}>
                Secure and Trusted Aadhaar Authentication, e-KYC Service &amp; Solutions
              </h1>
              <p data-aos="fade-right" data-aos-delay="200" style={{ textAlign: 'justify', fontSize: '1.1rem', color: '#2c3e50', lineHeight: 1.8, marginBottom: '30px', fontWeight: 500 }}>
                Empanelled with UIDAI as an ASA and AUA, C-DAC provides secure and reliable Aadhaar-based authentication and e-KYC services. Our solutions follow UIDAI guidelines while providing efficient and user-friendly experiences.
              </p>
              <div>
                <Button onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = '0 8px 20px rgba(9, 88, 217, 0.5)';
                }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 4px 12px rgba(9, 88, 217, 0.3)';
                  }} type="primary" size="large" style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', border: 'none', borderRadius: '8px', padding: '10px 30px', fontSize: '1rem', fontWeight: 600 }} onClick={() => { navigate('/registrationform'); window.scrollTo(0, 0); }}>
                  Get Started
                </Button>
              </div>
            </Col>
            <Col
              data-aos="fade-left"
              data-aos-offset="200"
              data-aos-duration="1000"
              data-aos-easing="ease-in-out"
              style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-start' }}
              xs={24} sm={24} md={12} lg={12} xl={12}
            >
              <div data-aos="zoom-in" className="banner-carousel-wrap" style={{ width: '100%', borderRadius: '8px', overflow: 'hidden', boxShadow: '0 20px 60px rgba(102, 126, 234, 0.18)', border: '1px solid rgba(102, 126, 234, 0.08)' }}>
                <Carousel className="banner-carousel" arrows infinite autoplay >
                  {items.map(item => {
                    return (
                      <div key={item.key} className="banner-slide" aria-label={item.title}>
                        <div className="banner-slide-inner" style={{ background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)', }}>
                          <img src={item.src} alt={item.title} style={{ width: '100%', objectFit: 'contain', userSelect: 'none', }} />
                        </div>
                      </div>
                    );
                  })}
                </Carousel>
              </div>
            </Col>
          </Row>

          {/* Transaction Stats Section */}
          <Row style={{ paddingTop: '30px', paddingBottom: '30px' }}>
            <Col xs={24} style={{ width: '100%' }}>
              <div className="transaction-bar">
                <div className='txn-div' data-aos="fade-up" data-aos-delay="0" data-aos-duration="800" data-aos-easing="ease-out">
                  <span className="txn-text">Total Transactions</span>
                  <span className="txn-number">{totalDisplay}</span>
                  <Button
                    type="primary"
                    size="large"
                    icon={<BarChartOutlined />}
                    onClick={() => setChartModalVisible(true)}
                    className="chart-modal-btn"
                  >
                    View Detailed
                  </Button>
                </div>
                <div className='txn-div' data-aos="fade-up" data-aos-delay="200" data-aos-duration="1000" data-aos-easing="ease-out">
                  <span className="txn-text">No. of Departments Integrated</span>
                  <span className="txn-number"><CountUp end={deptCount} duration={1200} /></span>
                </div>
                <div className='txn-div' data-aos="fade-up" data-aos-delay="400" data-aos-duration="1300" data-aos-easing="ease-out">
                  <span className="txn-text">Years of Operation</span>
                  <span className="txn-number"><CountUp end={yearsOfOperation} suffix={'+'} duration={1000} /></span>
                </div>
              </div>
            </Col>
          </Row>
        </div>
        <Modal
          open={chartModalVisible}
          onCancel={() => setChartModalVisible(false)}
          width="90%"
          centered
          footer={null}
          className="chart-modal"
        >
          <TransactionDetails />
        </Modal>
      </section>
    </>
  )
}

export default BannerHome